export default {
      id: "ar_associations-usage",
      viewBox: "0 0 80 80",
      url: "../dist/images/" + "sprite.svg#ar_associations-usage",
      toString: function () {
        return this.url;
      }
    }